import React from 'react';

import { Col } from '@opendoor/atoms/box';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import { IconMail } from '@tabler/icons-react';

import { Divider } from './Divider';

const WelcomeLeadPage: React.FC = () => {
  return (
    <Col className="min-h-screen bg-od-bg-primary py-12">
      <Col className="max-w-150 self-center px-8">
        <Divider />

        <Col className="pt-16 pb-12">
          <Text as="h1" className="text-header-md pb-8 text-center">
            Click the link in your email to view your Opendoor cash offer
          </Text>

          <Col className="items-center py-16">
            <IconMail size={64} color="#006AFF" />
          </Col>

          <Col className="px-12 pt-12">
            <Divider />
          </Col>

          <Text as="p" className="text-body-md pt-12 text-center">
            Questions? Contact our support team at{' '}
            <Link analyticsName="support-welcome" href="mailto:support@opendoor.com">
              support@opendoor.com
            </Link>
          </Text>
        </Col>
      </Col>
    </Col>
  );
};

export default WelcomeLeadPage;
